import { cn } from '@/utilities/ui'
import { type VariantProps } from 'class-variance-authority'
import * as React from 'react'
import { ArrowIcon } from './ArrowIcon'
import { ExternalLinkIcon } from './ExternalLinkIcon'
import Link from 'next/link'
import { buttonVariants } from '@/components/ui/Button'

export interface LinkButtonProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement>,
    VariantProps<typeof buttonVariants> {
  ref?: React.Ref<HTMLAnchorElement>
  linkIcon?: 'internal' | 'external' | 'none'
  href: string
  newTab?: boolean
}

export const LinkButton: React.FC<LinkButtonProps> = ({
  className,
  size,
  variant,
  ref,
  newTab,
  linkIcon = 'none',
  children,
  href,
  ...props
}) => {
  const newTabProps = newTab ? { rel: 'noopener noreferrer', target: '_blank' } : {}
  return (
    <Link
      className={cn(buttonVariants({ className, size, variant }))}
      ref={ref}
      href={href || ''}
      {...props}
      {...newTabProps}
    >
      {children}
      {linkIcon === 'internal' ? (
        <span>
          <ArrowIcon />
        </span>
      ) : linkIcon === 'external' ? (
        <span>
          <ExternalLinkIcon />
        </span>
      ) : null}
    </Link>
  )
}
